import styled from 'styled-components';

export const Container = styled.div`
  background: var(--app-bg-gradient);
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
`;

export const Form = styled.form.attrs({ noValidate: true })`
  display: flex;
  flex-direction: column;
  gap: 12px;
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  width: 400px;
  padding: 32px;
  margin: auto;

  @media screen and (max-width: 768px) {
    width: 90vw;
    padding: 24px;
  }
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
  display: block;
  position: relative;
  z-index: 2;
`;

export const ShowInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-sizing: border-box;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }
`;

export const Img = styled.img`
  width: 280px;
  margin-bottom: 40px;
`;

export const StyledButtonConfirmar = styled.button`
  background-color: var(--accent);
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: var(--text-on-accent);
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  flex: 1;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--accent);
    color: var(--text-on-accent);
  }

  &:active { transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
`;

export const StyledButtonVoltar = styled.button`
  background-color: var(--info);
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: var(--text-on-accent);
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  flex: 1;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--accent);
    color: var(--text-on-accent);
  }

  &:active { transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
`;
